/**
 * Format angka untuk badge mungil pada tombol kontrol (chat / peserta).
 *
 * - count <= 0   -> null  (badge disembunyikan)
 * - count <= max -> "5"   (angka apa adanya)
 * - count >  max -> "9+"  (dibatasi pada max)
 *
 * @param count jumlah item (mis. pesan belum dibaca, antrean ruang tunggu)
 * @param max   batas atas sebelum sufiks "+"; default 9
 */
export function formatBadgeCount(count: number, max = 9): string | null {
  if (!Number.isFinite(count) || count <= 0) return null;
  if (count <= max) return String(count);
  return `${max}+`;
}
